function groupLabel(key) {
  if (key === 'done') return '공격완료';
  if (key === 'partial') return '공격 미완료';
  return '미작성';
}

function memberLabel(member) {
  if (member.attackCount >= 3) return '3타';
  if (member.attackCount > 0) return `${member.attackCount}타`;
  return '0타';
}

export function RaidAttackStatus({ groups, compact = true }) {
  const normalized = groups || { done: [], partial: [], none: [] };
  return (
    <div className={`raid-home-attack-status ${compact ? 'compact' : ''}`}>
      {['done', 'partial', 'none'].map((key) => {
        const members = Array.isArray(normalized[key]) ? normalized[key] : [];
        return (
          <section className={`raid-home-status-group ${key}`} key={key}>
            <div className="raid-home-status-title">
              <span>{groupLabel(key)}</span>
              <b>{members.length}</b>
            </div>
            <div className="raid-home-status-chips">
              {members.length ? members.map((member) => (
                <span className="raid-home-member-chip" key={member.openid}>
                  <strong>{member.nickname}</strong>
                  <em>{memberLabel(member)}</em>
                </span>
              )) : <small>해당 멤버 없음</small>}
            </div>
          </section>
        );
      })}
    </div>
  );
}
